export default __webpack_public_path__ + "static/media/6.5b0740c1.jpg";